export default __webpack_public_path__ + "static/media/payment.813c8be1.svg";